// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OIQqx","content":"styles_content__2CVe7"};